import { RouteConfig } from 'vue-router';
import { OrganisationRoutes } from '../organisation/routes';
const DashboardModule = () =>
  import(
    /* webpackChunkName: 'dashboard' */ '@/modules/dashboard/DashboardModule.vue'
  );
const OrganizationsPage = () =>
  import(/* webpackChunkName: 'dashboard' */ './pages/OrganizationsPage.vue');
const SettingsPage = () =>
  import(/* webpackChunkName: 'dashboard' */ './pages/SettingsPage.vue');

export const DashboardRoutes: RouteConfig[] = [
  {
    path: '/dashboard',
    component: DashboardModule,
    meta: {
      middlewares: {
        requiresAuth: true
      }
    },
    children: [
      {
        path: '/',
        name: 'dashboard',
        component: OrganizationsPage
      },
      {
        path: 'settings',
        name: 'settings',
        component: SettingsPage
      },
      ...OrganisationRoutes
    ]
  }
];
